// src/components/repasses/components/RepasseDataTable.tsx (Ajuste Final)
import { DoneOutline, ErrorSharp } from "@mui/icons-material";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { RowDataRepasse } from "../types";

interface RepasseDataTableProps {
	data: RowDataRepasse[];
}

// DEFINIÇÃO ATUALIZADA DAS COLUNAS VISÍVEIS
const visibleColumns: (keyof RowDataRepasse)[] = [
	"RowNumber",
	"cnpjImobiliaria", // CNPJ da Imobiliária (entrada)
	"certificado",
	"valor",
	"tipo",
	"vencimento",
	"idComissao", // ID encontrado na API (Resultado do enriquecimento)
	"status",
	"mensagem",
];

// Função auxiliar para formatar CNPJ/CPF (opcional, dependendo de onde sua função de formatação está)
const formatDocument = (doc: string | undefined) => {
	if (!doc) return "";
	const cleaned = doc.replace(/\D/g, "");
	if (cleaned.length === 14) {
		// CNPJ
		return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
	}
	// Se não for CNPJ (pode ser o ID ou outra coisa), retorna o original
	return doc;
};

export const RepasseDataTable: React.FC<RepasseDataTableProps> = ({ data }) => {
	if (!data.length) return null;

	return (
		<TableContainer component={Paper} sx={{ maxHeight: 550, mt: 2 }}>
			<Table stickyHeader size="small">
				<TableHead>
					<TableRow>
						{visibleColumns.map((key) => (
							<TableCell key={key}>
								{/* Formatação amigável dos cabeçalhos */}
								{String(key) === "cnpjImobiliaria"
									? "CNPJ IMOBILIÁRIA"
									: String(key) === "idComissao"
									? "ID COMISSÃO"
									: String(key).toUpperCase()}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map((row) => (
						<TableRow key={row.RowNumber} hover>
							{visibleColumns.map((key) => (
								<TableCell key={key}>
									{key === "status" ? (
										<Box display="flex" alignItems="center" gap={1}>
											{row[key] === "inválido" ? <ErrorSharp sx={{ color: "#ff3022" }} /> : <DoneOutline sx={{ color: "#3ae940" }} />}
											<Typography fontWeight="bold" color={row[key] === "inválido" ? "#ff3022" : "#3ae940"}>
												{String(row[key] ?? "")}
											</Typography>
										</Box>
									) : key === "RowNumber" ? (
										<Typography fontWeight="bold" color="text.secondary">
											#{(Number(row[key]) + 1).toString().padStart(3, "0")}
										</Typography>
									) : key === "cnpjImobiliaria" ? (
										// Aplica formatação ao CNPJ
										formatDocument(row[key])
									) : (
										// Renderiza qualquer outro valor
										String(row[key] ?? "")
									)}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
